<template>
	<button
		type="button"
		class="ring-focus mx-0.5 flex h-full items-center justify-center px-1 text-xl outline-hidden hover:bg-gray-50 focus:h-4/5 active:bg-gray-100"
	>
		<slot />
	</button>
</template>
